import { makeStyles } from '@material-ui/core/styles';
import { deepPurple } from '@material-ui/core/colors';



export default makeStyles((theme) => ({
    "@global": {
      '.MuiTypography-root': {
        [theme.breakpoints.down("xs")]: {
          fontSize: '60%'
        },
      },
      '.MuiOutlinedInput-root': {
        [theme.breakpoints.down("xs")]: {
          fontSize: '100%'
        }, 
      },
      '.MuiButtonBase-root': {
        [theme.breakpoints.down("xs")]: {
          fontSize: '100%'
        }, 
      }  
    },
    appBar:{
        display:'flex',
        flexDirection:'row',
        backgroundColor:'#222',
        justifyContent: 'space-between',
        alignItems: 'center',
        [theme.breakpoints.down("xs")]: {
          width:'100%',
          justifyContent: 'space-between'
        },
    },
    brand:{
        marginLeft:'2%',
        width:'150px',
        display:'flex',
        alignItems:'center',
        justifyContent:'center',
        [theme.breakpoints.down('xs')]: {
          width:'100px',
          marginLeft:'none'
        }
    },
    image:{
      marginLeft:'20px',
      [theme.breakpoints.down('xs')]: {
        height:'40px',
        width:'40px',
        marginLeft:'0px',
      }
    },
    heading:{
        textDecoration:'none',
        color: 'white',
    },
    signedOut:{
        display: 'flex',
        justifyContent: 'space-between',
        width:'200px',
        [theme.breakpoints.down("md")]: {
          width:'190px',
          height:'30px',
          justifyContent:'space-around'
        },
    },
    profile: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '500px',
        [theme.breakpoints.down("xs")]: {
          width:'150px',
          height:'30px',
          justifyContent:'space-around'
        },
      },
      userName: {
        display: 'flex',
        alignItems: 'center',
        [theme.breakpoints.down("xs")]: {
          marginRight:'8%'
        },
      },
      brandContainer: {
        display: 'flex',
        alignItems: 'center',
      },
      purple: {
        color: theme.palette.getContrastText(deepPurple[500]),
        backgroundColor: deepPurple[500],
        [theme.breakpoints.down("xs")]: {
          display:'none'
        },
      },
      logout:{
        textAlign:'center',
        [theme.breakpoints.down("xs")]: {
        fontSize:'45%'
          
          
        },
      },
      signin:{
        [theme.breakpoints.down("xs")]: {
          
        },
      }

}))